import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import swal from "sweetalert";
import Loader from "../Common/Loader";
import MedicineDropdown from "../AppsMenu/Patients/Components/MedicineDropdown";
import { createPrintQRAction } from "../../../store/actions/printQRActions";

const AddPrintQR = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Add null check with fallback values
  const printQRState = useSelector((state) => state.printQR) || {};
  const { loading = false, success = false, createdPrintQR = null, error = null } = printQRState;



  const [formData, setFormData] = useState({
    medicine_id: "",
    batch_no: "",
    mfg_date: "",
    qty: "",
    no_of_carton: "",
  });
  const [errors, setErrors] = useState({});

  // Note: Do NOT fetch medicines here. The MedicineDropdown component 
  // handles its own lazy loading with pagination. This prevents infinite API calls.





  const validateForm = () => {
    const newErrors = {};
    if (!formData.medicine_id) newErrors.medicine_id = "Medicine is required";
    if (!formData.batch_no?.trim()) newErrors.batch_no = "Batch number is required";
    if (!formData.mfg_date) newErrors.mfg_date = "Manufacturing date is required";
    
    // Check qty - must be greater than 0, not 0 or blank
    const qtyValue = parseInt(formData.qty);
    if (!formData.qty || isNaN(qtyValue) || qtyValue <= 0) {
      newErrors.qty = "Quantity must be greater than 0";
    }
    
    // Check no_of_carton - must be greater than 0, not 0 or blank
    const cartonValue = parseInt(formData.no_of_carton);
    if (!formData.no_of_carton || isNaN(cartonValue) || cartonValue <= 0) {
      newErrors.no_of_carton = "Number of cartons must be greater than 0";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFieldChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: "" }));
  };

  const handleMedicineChange = (selected) => {
    // Handle both single selection (for MedicineDropdown) and null
    const medicineId = selected?.value || (Array.isArray(selected) && selected[0]?.value) || "";
    setFormData(prev => ({ 
      ...prev, 
      medicine_id: medicineId,
    }));
    setErrors(prev => ({ ...prev, medicine_id: "" }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
  
    const payload = {
      medicine_id: parseInt(formData.medicine_id),
      batch_no: formData.batch_no,
      mfg_date: formData.mfg_date,
      qty: parseInt(formData.qty),
      no_of_carton: parseInt(formData.no_of_carton),
    };
  
    try {
      const result = await dispatch(createPrintQRAction(payload));
      
      if (result?.data?.status === "success" || result?.status === 200) {
        // Show success message
        // swal("Success", "QR codes generated successfully!", "success");
        
        // Navigate after success
        setTimeout(() => {
          navigate("/batch-QRs");
        }, 500);
      }
    } catch (error) {
      console.error("Error creating QR codes:", error);
      // Error handling is done by the action's showErrorAlert
    }
  };

  const totalQRCodes = formData.qty && formData.no_of_carton 
    ? parseInt(formData.qty) * parseInt(formData.no_of_carton)
    : 0;



  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end mb-3">
          <Link to="/batch-QRs">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* MEDICINE SELECTION */}
              <div className="mb-3">
                <label className="form-label">
                  Select Medicine <span className="text-danger">*</span>
                </label>
                <MedicineDropdown
                  isMulti={false}
                  value={formData.medicine_id ? { value: formData.medicine_id, label: '' } : null}
                  onChange={handleMedicineChange}
                />
                {errors.medicine_id && <div className="text-danger mt-1">{errors.medicine_id}</div>}
              </div>

            

              {/* BATCH NUMBER */}
              <div className="mb-3">
                <label className="form-label">
                  Batch Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.batch_no}
                  onChange={(e) => handleFieldChange("batch_no", e.target.value)}
                  placeholder="Enter batch number"
                  disabled={loading}
               
                />
                {errors.batch_no && <div className="text-danger mt-1">{errors.batch_no}</div>}
              </div>

              {/* MANUFACTURING DATE */}
              <div className="mb-3">
                <label className="form-label">
                  Manufacturing Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={formData.mfg_date}
                  onChange={(e) => handleFieldChange("mfg_date", e.target.value)}
            
                  max={
                    new Date()
                      .toISOString()
                      .split("T")[0]
                  }
                  disabled={loading}
               
                />
                {errors.mfg_date && <div className="text-danger mt-1">{errors.mfg_date}</div>}
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Quantity per Carton <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.qty}
                      onChange={(e) => handleFieldChange("qty", e.target.value)}
                      placeholder="Enter quantity per carton"
                      min="1"
                      disabled={loading}
                     
                    />
                    {errors.qty && <div className="text-danger mt-1">{errors.qty}</div>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Number of Cartons <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={formData.no_of_carton}
                      onChange={(e) => handleFieldChange("no_of_carton", e.target.value)}
                      placeholder="Enter number of cartons"
                      min="1"
                      disabled={loading}
                   
                    />
                    {errors.no_of_carton && <div className="text-danger mt-1">{errors.no_of_carton}</div>}
                  </div>
                </div>
              </div>

            

              {/* SUBMIT BUTTON */}
              <button 
                type="submit" 
                className="btn btn-primary" 
                disabled={loading}
                style={{ minWidth: "150px" }}
              >
                {loading ? (
                  <>
                    <Loader size="sm" /> Generating...
                  </>
                ) : (
                  "Generate QR Codes"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPrintQR;
